import useMutation from "../useMutation";

function useWTUpdateProdExport(id) {
  return useMutation({
    path: `/api/v1/warehouse-transfers/${id}/transfer-details/transferDetailId/export`,
    method: "PUT",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/warehouse-transfers/${id}`,
      shouldRevalidate: true,
    },
  });
}

export default useWTUpdateProdExport;
